import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import cn from "classnames";
import { t } from "i18next";
import { noDataPlugin } from "plugins";
import { Bar } from "react-chartjs-2";

import { ChartBarProps } from "./ChartBar.types";
import { CHART_BAR_TABS } from "./constants";
import { useChart } from "./hooks";

import styles from "./ChartBar.module.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ChartBar = ({
  datepicker,
  dateRange,
  activeRangeType,
  onRangeTypeChange,
  data,
  isLoading
}: ChartBarProps) => {
  const { state, options } = useChart({
    dateRange,
    activeRangeType,
    barsData: data,
    isLoadingData: isLoading
  });

  return (
    <div className={styles.chart}>
      {datepicker && (
        <div className={styles.chart__header}>
          <div className={styles.chart__header_tabsContainer}>
            {CHART_BAR_TABS?.map((tab) => (
              <div
                key={tab.label}
                className={cn(styles["chart__header--tabs"], {
                  [styles["chart__header--tabs-active"]]:
                    activeRangeType === tab.value
                })}
                onClick={() => onRangeTypeChange(tab.value)}
              >
                {t(tab.label)}
              </div>
            ))}
          </div>
          <div className={styles["chart__header--datepicker"]}>
            {datepicker}
          </div>
        </div>
      )}

      <div className={styles.chart__bar}>
        <Bar data={state} options={options} plugins={[noDataPlugin]} />
      </div>
    </div>
  );
};

export default ChartBar;
